import { put, call, takeLatest } from 'redux-saga/effects'
import {
  imageUploadActionSuccess,
  imageConvertActionSuccess,
  imageUploadActionFailed,
  imageConvertActionFailed,
} from '../actions/image.actions'
import { hideLoader } from '../actions/loader.actions'
import {
  IMAGE_UPLOAD_REQUESTED,
  IMAGE_CONVERT_REQUESTED
} from '../types/image.types'
import { postFormData, post } from '../../helpers/fetch'

import * as Sentry from '@sentry/react'

export function* imageUpload({ payload: { image } }) {
  const warn = () => {
    console.warn('imageUpload attempt failed')
  }
  let retries = 3

  while (retries--) {
    try {
      const response = yield call(postFormData, `${process.env.REACT_APP_API_URL}/`, { image })

      if (response.status === 200) {
        const imageSrc = yield response.text()

        yield put(imageUploadActionSuccess(process.env.REACT_APP_API_URL + imageSrc))

        return
      } else {
        warn()
      }
    } catch (e) {
      warn()
      Sentry.captureException(e)
    }
  }

  yield put(imageUploadActionFailed())
}

export function* imageConvert({ payload: data }) {
  try {
    const response = yield call(post, `${process.env.REACT_APP_API_URL}/convert`, { ...data })
    if (response.status !== 200) {
      yield put(imageConvertActionFailed())
      yield put(hideLoader())
    }
    const image = yield response.text()
    const imageSrc = image.split('&')

    yield put(imageConvertActionSuccess(imageSrc[0], imageSrc[1] / 1024))
  } catch (e) {
    yield put(imageConvertActionFailed())
    yield put(hideLoader())
    Sentry.captureException(e)
  }
}

export default [
  takeLatest(IMAGE_UPLOAD_REQUESTED, imageUpload),
  takeLatest(IMAGE_CONVERT_REQUESTED, imageConvert)
]
